import getAvailableCategoriesToPaymentOptionsMap
from './ApmExperimentSelectors/getAvailableCategoriesToPaymentOptionsMap';
import getSelectedPaymentCategory from './ApmExperimentSelectors/getSelectedPaymentCategory';

export default (state) => {
  const selectedCategory = getSelectedPaymentCategory(state);
  const availableCategoriesToPaymentOptionsMap = getAvailableCategoriesToPaymentOptionsMap(state);
  
  return availableCategoriesToPaymentOptionsMap?.[selectedCategory] || [];
};
